module.exports = __webpack_public_path__ + "img/leftIcon.82e32388.png";